



















































































































































































import VueOptions from '@utils/VueOptions'
import Back from '@modules/ui/buttons/Back'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import ActivationForm from '@superUI/Forms/ActivationForm'
import PromptModal from '@components/PromptModal'
import FullScreenModal from '@components/FullScreenModal'
import RequestButton from '@components/RequestButton'
import EventSelector from '@superUI/Selectors/EventSelector'

settings =
  name: "OfferEdit"
  components: { Back, SuperContainerView, ActivationForm, PromptModal, FullScreenModal, RequestButton, EventSelector }
  resources:
    offer:
      resourceName: "offer"
      slug: "offers/:offerId/edit"

  vue:
    props: ['offerId']

    data: ->
      selectedSpace: null
      selectedActivation: []
      selectedSpaces: []
      activations_to_apply: {}
      selectedActivationToApply: null

      should_update: true
      tab: null

      openMoreActions: false
      deleteMode: false

      editActivationSnapshotModal: false
      selectedActivationSnapshot: ''

      actionModal:
        show: false
        title: ''
        button:
          label: ''
          handler: null

    beforeUpdate: ->
      if @prime.offer && @should_update
        activation_snapshots = @prime.offer.activation_snapshots

        for spaceName, activation of activation_snapshots
          @selectedActivation.push spaceName
          @activations_to_apply[spaceName] = activation.name

        @should_update = false

    computed:
      eventExists: -> @ctxEvent(@prime.offer).name?

    methods:
      onSave: (item) -> @$router.push({ name: 'OfferShowPage', params: { offerId: item.id } })

      openSpaces: ->
        @prime.context.event?.spaces || {}

      hiAddSpace: ->
        if !@selectedSpaces.includes @selectedSpace
          @selectedSpaces.push(@selectedSpace)
          @deleteMode = false

      hiRemoveSpace: (space) ->
        @selectedSpaces = @selectedSpaces.filter((item) -> item != space)
        delete @activations_to_apply[space]

      hiApplyActivation: (space, activationSelectIndex) ->
        # activation = document.getElementById("activation_select-#{space}").value
        activation = @selectedActivationToApply
        @activations_to_apply[space] = activation
        @prime.offer.activations_to_apply = @activations_to_apply
        @activations_to_apply = Object.assign({}, @activations_to_apply)
        @saveItem('prime.offer', null, { skipCallbacks: true })
        @selectedSpaces = @selectedSpaces.filter((item) -> item != space)
        @deleteMode = false

      hiRemoveActivation: (space) ->
        @selectedActivation = @selectedActivation.filter((item) -> item != space)
        delete @activations_to_apply[space]
        @prime.offer.activations_to_apply = @activations_to_apply
        @hiRemoveSpace(space)
        # @selectedSpaces = Object.assign({}, @selectedSpaces)

      promptToDeleteActivation: (space) ->
        title = "Would you like to remove this activation from the offer?"
        show = true

        label = 'Remove Activation'
        handler = () => @hiDeleteActivationSnapshot(space)
        style = 'bg-red-dark'

        button = { label, handler, style }
        @actionModal = { title, show, button }

      hiDeleteActivationSnapshot: (space) ->
        @hiRemoveSpace(space)
        delete @prime.offer.activation_snapshots[space]
        @saveItem('prime.offer', null, { skipCallbacks: true })
        @deleteMode = false
        @actionModal.show = false

      formatedSpaceName: (space) ->
        "#{space.name} (#{space.size}: #{space.category})"

      hiEditActivationSnapshot: (space) ->
        return if @deleteMode
        @selectedActivationSnapshot = space
        @editActivationSnapshotModal =  true

      hiEventSelected: (event) ->
        @saveItem('prime.offer', { id: @prime.offer.id, new_event_id: event.id }, { skipCallbacks: true })

    watch:
      editActivationSnapshotModal: (show) ->
        @saveItem('prime.offer', null, { skipCallbacks: true }) if !show

      deleteMode: ->
        @openMoreActions = false

export default VueOptions.vue settings
